import NodeCache from "node-cache";

declare global {
  var cache: NodeCache;
}

if (!globalThis.cache) {
  globalThis.cache = new NodeCache();
}
